module.exports = __webpack_public_path__ + "front/img/c8.d5ad51da.png";